module.exports = __webpack_public_path__ + "img/icon-edit.cc77b47d.svg";